import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';

import { requestFailed } from '../../bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import {getPersonalSpace, GetPersonalSpaceAction, getPersonalSpaceSucceded, isGetPersonalSpaceAction} from '../actions/PersonalSpaceActions';
import { callViaApiService } from '../restApi/PersonalSpace';

export function* rootPersonalSpaceSaga(): SagaIterator {
  yield takeEvery(getPersonalSpace, handleGetPersonalSpace);
}

export function* handleGetPersonalSpace(action: GetPersonalSpaceAction) {
  try {
    if (isGetPersonalSpaceAction(action)) {
      const result =  yield call(callViaApiService);
      yield put(getPersonalSpaceSucceded(result.personalSpace));
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}